import React from 'react';
import PropTypes from 'prop-types';

const IconTriangle = ({ size, fill }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill={fill}
        viewBox="0 0 13 13"
    >
        <path d="M.122 10.757L5.661.488c.081-.15.195-.27.339-.358.145-.087.3-.13.47-.13.168 0 .324.043.468.13.145.088.258.208.34.358l5.538 10.269c.169.307.164.612-.014.918-.082.142-.194.253-.336.336-.143.083-.295.124-.459.124H.931c-.163 0-.316-.041-.458-.124s-.254-.194-.335-.336c-.179-.306-.184-.612-.016-.918m5.31-6.791L5.553 7.3c0 .049.023.089.072.121.048.031.105.047.173.047h1.334c.067 0 .125-.016.171-.047.046-.032.07-.072.074-.121l.13-3.347c0-.059-.023-.105-.071-.14-.062-.053-.12-.08-.173-.08H5.675c-.052 0-.11.027-.172.08-.048.035-.071.085-.071.153m.114 6.061c0 .068.022.126.068.172.045.046.1.069.163.069h1.384c.062 0 .117-.023.163-.069.045-.046.068-.104.068-.172V8.643c0-.069-.023-.126-.068-.173-.046-.046-.1-.069-.163-.069H5.777c-.063 0-.118.022-.163.068-.046.048-.068.104-.068.174v1.384z" />
    </svg>
);

IconTriangle.propTypes = {
    size: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired,
};

IconTriangle.defaultProps = {
    size: 12,
    fill: '#666666',
};

IconTriangle.displatName = 'Triangle';

export default IconTriangle;
